import { createContext, ReactNode, useState } from 'react';
import { EventContextValue, EventState } from '@contexts/event/event.type';

export const EventContext = createContext<EventContextValue>({
  eventState: {},
  setEventState: () => {},
  currentStep: '',
  setCurrentStep: () => {},
});

export const EventProvider = ({ children }: { children: ReactNode }) => {
  const [eventState, setEventState] = useState<EventState>({});
  const [currentStep, setCurrentStep] = useState<string>('');

  return (
    <EventContext.Provider
      value={{
        eventState,
        setEventState,
        currentStep,
        setCurrentStep,
      }}>
      {children}
    </EventContext.Provider>
  );
};
